import React, { useState, useMemo } from "react";
import { createStaticSelectComponent } from "../factories";
import { ResponsiveCommandSelect, SelectOption } from "../../responsive-select";
import {
  CONTACT_STATUS_OPTIONS,
  CONTRACT_TYPE_OPTIONS,
  INDUSTRY_OPTIONS,
  SOURCE_OPTIONS,
} from "../options";

// Contact Status Select Component
export const ContactStatusSelect = createStaticSelectComponent(
  CONTACT_STATUS_OPTIONS,
  "Select status..."
);

// Industry Select Component
export const IndustrySelect = createStaticSelectComponent(INDUSTRY_OPTIONS, "Select industry...");

// Source Select Component
export const SourceSelect = createStaticSelectComponent(SOURCE_OPTIONS, "Select source...");

// Enhanced Contract Type Select Component with Search
interface ContractTypeSelectProps {
  value?: string;
  onValueChange?: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  required?: boolean;
  className?: string;
}

export function ContractTypeSelect({
  value,
  onValueChange,
  placeholder = "Search contract types...",
  disabled = false,
  error = false,
  required = false,
  className,
}: ContractTypeSelectProps) {
  const [searchTerm, setSearchTerm] = useState("");

  // Filter options based on search term
  const filteredOptions = useMemo(() => {
    if (!searchTerm) return CONTRACT_TYPE_OPTIONS;

    return CONTRACT_TYPE_OPTIONS.filter((option) =>
      option.label.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm]);

  return (
    <ResponsiveCommandSelect
      value={value || ""}
      onValueChange={onValueChange || (() => {})}
      options={filteredOptions}
      placeholder={placeholder}
      disabled={disabled}
      title="Contract Type"
      description="Select the type of contract for this contact"
      className={className}
    />
  );
}
